<template>
  <v-container fluid>
    <v-breadcrumbs :items="breadcrumbs" />
    <v-card v-if="course != null">
      <v-card-title>{{course.name}}</v-card-title>
      <v-card-text>
        <div class="mb-4">
          Price: {{course.pricePerWeek | currency}} per week
        </div>
        <div>
          {{course.description}}
          <!-- {{course.descriptionHeading}} -->
        </div>
        
        <!-- <div>
          Schedules ({{course.scheduleStart | formatDate}} - {{course.scheduleEnd | formatDate}})
          <v-list>
            <v-list-item
              v-for="(event) in course.events"
              :key="event.id"
            >{{formatDate(event.start.dateTime, false)}} to {{formatDate(event.end.dateTime, true)}} {{event.summary}}</v-list-item>
          </v-list>
        </div> -->

        <!-- <v-expansion-panels :popout="true" v-if="sessionCount > 0">
          <v-expansion-panel>
            <v-expansion-panel-header>{{sessionCount}} sessions available</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-list>
                <v-list-item v-for="(session) in sessions" :key="session.name">{{session.name}}</v-list-item>
              </v-list>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels> -->
      </v-card-text>

      <v-card-text>
        Choose the weeks you would like to register
        <div class="my-4">{{selectedWeeksCount}} weeks selected</div>
        <v-simple-table dense>
          <!-- <thead>
            <tr>
              <td>
                <v-checkbox v-model="allWeeks" :ripple="false" @click="toggleCourseWeeks(course)" />
              </td>
              <td>All Weeks</td>
            </tr>
          </thead> -->
          <tr v-for=" (w, index) in weeks" :key="index">
            <td style="width: 50px;">
              <v-checkbox @change="updateWeeksCount" v-model="w.selected" :ripple="false" />
            </td>
            <td>Week {{index+1}}, {{w.week.start | formatDate}} ~ {{w.week.end | formatDate}}</td>
            <!-- <td>
              <v-chip class="mr-5 mb-5" v-for=" t in w.topics" :key="t.id">{{t.name}}</v-chip>
            </td> -->
          </tr>
        </v-simple-table>
      </v-card-text>
<hr/>
      <v-card-actions>
        <v-spacer />
        <!-- <v-btn color="orange" :disabled="course.quantity === 0" @click="addItem(course)">Add to Cart</v-btn> -->
        <v-btn
          color="orange"
          :disabled="course.quantity === 0"
          @click="checkout(course)"
        >Register Now</v-btn>
        <v-spacer />
      </v-card-actions>
      <br/>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      course: null,
      allWeeks: true,
      selectedWeeksCount: 0,
      breadcrumbs: [
        {
          text: "Virtual Camp",
          disabled: false,
          to: "/camp"
        },
        {
          text: "course",
          disabled: true
        }
      ],
      // week2Topics: [
      //   {
      //     week: { start: "2020-06-01", end: "2020-06-07", id: "202001" },
      //     topics: [
      //       { name: "Topic 1", id: 1 },
      //       { name: "Topic 2", id: 2 }
      //     ],
      //     schedules: [1, 2, 3],
      //     selected: true
      //   }
      // ]
    };
  },
  filters: {
    formatDate(value){
      return new moment(value).format("ddd MMM DD, YYYY");
    }
  },
  computed: {
    sessions() {
      return this.course.sessions;
    },
    sessionCount() {
      return this.course.sessions ? this.course.sessions.length : 0;
    },
    weeks() {
      const schedules = this.course.courseSchedules;
      const weeks = schedules.reduce((acc, schedule) => {
        const date = moment(schedule.start);

        // create a composed key: 'year-week'
        const yearWeek = `${date.year()}${date.week()}`;

        // add this key as a property to the result object
        if (!acc[yearWeek]) {
          acc[yearWeek] = [];
        }

        // push the current date that belongs to the year-week calculated befor
        acc[yearWeek].push({date, scheduleId: schedule.id});

        return acc;
      }, {});

      const weekObjects = Object.keys(weeks).map(function(key) {
        const year = key.substring(0,4);
        const week = key.substring(4,6);
        console.log(`${week} - ${year}`)
        const start = moment().day("Monday").year(year).week(week).toDate();
        const end =  moment().day("Friday").year(year).week(week).toDate();
        
        const scheduleIds = weeks[key].map( v => v.scheduleId );
        const dates = weeks[key].map( v => v.date );
        // const end = new Date(Math.max.apply(null,dates));
        // const start = new Date(Math.min.apply(null,dates));
        return { week: { id: key, start, end}, schedules: scheduleIds, dates, selected: true}
      });

      //Filter out weeks of the past
      const today = moment();
      console.log(weekObjects);
      return weekObjects.filter(w => moment(w.week.start).isAfter(today));

    }
  },
  methods: {
    ...mapActions(["addMessage", "addErrorMessage", "updateCart"]),
    async initCourse() {
      const result = await this.$axios
        .get("public/classroom/course", {
          params: { courseId: this.$route.params.id }
        })
        .then(resp => {
          this.course = resp.data;
          this.events = this.course.events;
          //Set name for breadcrumbs
          this.breadcrumbs[1].text = this.course.name;

          this.updateWeeksCount();
        })
        .catch(() => {
          this.$store.dispatch(
            "addMessage",
            "Error loading course from server"
          );
        });

      return result;
    },
    formatDate(dataTime, timeOnly) {
      if (timeOnly) {
        return new moment(dataTime.value).format("h:mm a");
      } else {
        return new moment(dataTime.value).format("ddd MMM DD, YYYY h:mm a");
      }
    },
    updateWeeksCount() {
      this.selectedWeeksCount = this.weeks.filter(w => w.selected).length;
    },
    toggleCourseWeeks() {
      this.weeks.forEach( w => {
        w.selected = !this.allWeeks;
      })
    },
    addItem(course) {
      const selectedWeeks = this.weeks.filter( w => w.selected );

      const order = {
        item: Object.assign({weeks: selectedWeeks}, course),
        quantity: 1,
        isAdd: true
      };
      this.updateCart(order);
    },
    checkout(course) {
      const selectedWeeks = this.weeks.filter( w => w.selected );

      const order = {
        item: Object.assign({weeks: selectedWeeks}, course),
        quantity: 1,
        pricePerWeek: course.pricePerWeek,
        numberOfWeeks: selectedWeeks.length,
        isAdd: true
      };
      this.updateCart(order);

      this.$router.push("/cart");
    }
  },
  mounted() {
    this.initCourse();
  }
};
</script>
